/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AvailabilityDto } from '../models/AvailabilityDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AvailabilityControllerService {
    /**
     * @param startDateTime
     * @param endDateTime
     * @returns AvailabilityDto OK
     * @throws ApiError
     */
    public static getAllAvailabilities(
        startDateTime: string,
        endDateTime: string,
    ): CancelablePromise<Array<AvailabilityDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/availabilities',
            query: {
                'startDateTime': startDateTime,
                'endDateTime': endDateTime,
            },
        });
    }
    /**
     * @param shiftTemplateId
     * @param startDateTime
     * @param endDateTime
     * @returns AvailabilityDto OK
     * @throws ApiError
     */
    public static getShiftTemplateAvailabilities(
        shiftTemplateId: number,
        startDateTime: string,
        endDateTime: string,
    ): CancelablePromise<Array<AvailabilityDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/availabilities/shift-template/{shiftTemplateId}',
            path: {
                'shiftTemplateId': shiftTemplateId,
            },
            query: {
                'startDateTime': startDateTime,
                'endDateTime': endDateTime,
            },
        });
    }
    /**
     * @param resourceId
     * @param startDateTime
     * @param endDateTime
     * @returns AvailabilityDto OK
     * @throws ApiError
     */
    public static getResourceAvailabilities(
        resourceId: number,
        startDateTime: string,
        endDateTime: string,
    ): CancelablePromise<Array<AvailabilityDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/availabilities/resource/{resourceId}',
            path: {
                'resourceId': resourceId,
            },
            query: {
                'startDateTime': startDateTime,
                'endDateTime': endDateTime,
            },
        });
    }
    /**
     * @param resourceId
     * @param date
     * @returns AvailabilityDto OK
     * @throws ApiError
     */
    public static getResourceAvailabilitiesForDate(
        resourceId: number,
        date: string,
    ): CancelablePromise<Array<AvailabilityDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/availabilities/resource/{resourceId}/date/{date}',
            path: {
                'resourceId': resourceId,
                'date': date,
            },
        });
    }
    /**
     * @param date
     * @returns AvailabilityDto OK
     * @throws ApiError
     */
    public static getAllAvailabilitiesForDate(
        date: string,
    ): CancelablePromise<Array<AvailabilityDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/availabilities/date/{date}',
            path: {
                'date': date,
            },
        });
    }
}
